export default function isLastIndex<T>(index: number, array: T[]): boolean {
  return index === array.length - 1;
}
